import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import { get, includes } from 'lodash';
import { CONTENT_TYPE, LOGIN_PAGE_URL } from '@/apis/constant';
import {
  UPDATE_PAYMENT_MAX_ATTEMPTS_EXCEEDED_ERROR_CODE,
  UNSUPPORTED_APM_PLAN_ERROR_CODE,
  INR_SESSION_EMAIL_IS_INCORRECT_ERROR_CODE,
  INR_DELAYED_PROVISIONING_INITIATED_ERROR_CODE,
  INR_HAVE_PENDING_INVOICE_ERROR_CODE,
} from '@/common/constants';
import { translation } from '@/plugins/i18n';

export default (axiosResponse) => {
  return new Promise((resolve, reject) => {
    const serverData = axiosResponse?.data || {};
    const errorCode = serverData.errorCode;
    const limitBlockMessage = translation?.('billing.common.limit_block');
    if (
      errorCode === 201 ||
      (axiosResponse.request?.responseURL?.endsWith("/signin") &&
        !axiosResponse.request?.responseURL?.includes("/paynow/lcr/signin")) //User Log Out
    ) {
      window.location = LOGIN_PAGE_URL;
      return reject(new Error(""));
    } else if (errorCode === 7300) { // for recaptcha when the api call meet limit
      const vm = new Vue();
      const result = serverData.result || {};
      const { data, headers } = axiosResponse.config || {};
      const contentType = get(headers, 'Content-Type');

      if (vm.$createPopupCaptcha && includes(contentType, CONTENT_TYPE.URL_ENCODED)) {
        const popupCaptcha = vm.$createPopupCaptcha({
          type: result.type,
          routingUrl: result.routingUrl || window.resourceAccountIdRoutingURl,
          errorMessage: serverData.errorMessage,
        }, async (captcha) => {
          if (axiosResponse.config) {
            if (contentType === CONTENT_TYPE.URL_ENCODED) {
              axiosResponse.config.data = qs.stringify({ ...qs.parse(data), recaptcha: captcha });
            }
          }

          return axios(axiosResponse.config)
            .then((result) => {
              popupCaptcha && popupCaptcha.hide();
              resolve(result);
            }, (e) => reject(e));
        });
      } else {
        // todo the architecture group does not support recapture in application/json format for the time being
        return reject(new Error(limitBlockMessage));
      }
    } else if (errorCode === 7302) { // for block when the api call meet limit
      return reject(new Error(limitBlockMessage));
    } else if (axiosResponse.request?.url === '/billing/plan/phone/sendCode' || axiosResponse.request?.url === '/billing/plan/phone/verifyCode') { // 2FA feature for sendCode/verifyCode
      return resolve(serverData);
    } else if (errorCode === UNSUPPORTED_APM_PLAN_ERROR_CODE || errorCode === UPDATE_PAYMENT_MAX_ATTEMPTS_EXCEEDED_ERROR_CODE) { // APM unsupported plan OR APM(P24 & Furikomi) exceed maximum count for update payment methods
      return reject(serverData);
    } else if (errorCode === 9503) { // generateOnSessionSignature: user data not found
      window.location = LOGIN_PAGE_URL;
      return reject(new Error(serverData.errorMessage));
    } else if (
      errorCode === INR_SESSION_EMAIL_IS_INCORRECT_ERROR_CODE ||
      errorCode === INR_DELAYED_PROVISIONING_INITIATED_ERROR_CODE ||
      errorCode === INR_HAVE_PENDING_INVOICE_ERROR_CODE
    ) {
      return reject(serverData);
    } else if (errorCode !== 0 && serverData.errorMessage) {
      if (!!serverData.result && Reflect.has(serverData.result, 'zuoraOtage') && !!serverData.result.zuoraOtage) {
        return reject(serverData);
      }
      return reject(new Error(serverData.errorMessage));
    } else {
      return resolve(serverData);
    }
  });
}
